import Pangkat from './Pangkat'

export default Pangkat